/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class LoginViewController {
    /** @ngInject */
    constructor($state, $mdToast, authenticationService, notificationService, $log, configuration) {
        this.$state = $state;
        this.$mdToast = $mdToast;
        this.authenticationService = authenticationService;
        this.notificationService = notificationService;
        this.$log = $log;
        this.configuration = configuration;
        this.$log.debug('Controller \'LoginView\' loaded');
    }

    $onInit() {
        // Empty strings are required to avoid 'null' or 'undefined' values are sent to the server.
        this.credentials = {
            username: '',
            password: ''
        };
        this.loginDisabled = false;
    }

    /**
     * Dispatches the user login request to the dedicated service.
     */
    login() {
        this.loginDisabled = true;
        this.authenticationService.login(this.credentials).then(() => {
            // Activates the target state.
            this.$state.go(this.$state.params.target.name, this.$state.params.target.params);
        }).catch(error => {
            if (error.status === 401) {
                this.notificationService.pushMessage('authentication.error', this.configuration.NOTIFIER_LEVEL_ERROR);
            } else if (error.status === 403) {
                this.notificationService.pushMessage('authorization.accessdenied',
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            } else {
                this.$log.error(error);
                this.notificationService.pushMessage(`server.error.${error.status}`,
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            }
        }).finally(() => {
            this.loginDisabled = false;
        });
    }
}

export const loginViewComponent = {
    template: require('./login-view.html'),
    controller: LoginViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/security/component/LoginView.js